if (!customElements.get('product-service-card')) {
  class ProductCard extends Product {
    constructor() {
      super();

      this.bindEvents();
    }

    bindEvents() {
      this.initForm();

      this.addEventListener('change', (event) => {
        this.updateAddedVariant();
      });
    }

    updateAddedVariant() {
      const selectedVariant = this.querySelector('.js-product-variant:checked');
      const mainIdInput = this.querySelector('input[name="id"]');

      if (selectedVariant && mainIdInput) mainIdInput.value = selectedVariant.value;
    }
  }

  customElements.define('product-service-card', ProductCard);
}
